// import { Component } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
// import { ActivatedRoute, Router, RouterLink } from '@angular/router';
// import { ApiService } from '../../core/api.service';

// @Component({
//   selector: 'app-customer-register',
//   standalone: true,
//   imports: [CommonModule, FormsModule, RouterLink],
//   templateUrl: './customer-register.component.html',
//   styleUrl: './customer-register.component.css'
// })
// export class CustomerRegisterComponent {
//   loading = false;
//   error = '';

//   form = {
//     name: '',
//     email: '',
//     phone: '',
//     password: ''
//   };

//   constructor(private api: ApiService, private router: Router,   private route: ActivatedRoute) {}

//   register() {
//     this.error = '';

//     if (!this.form.name || !this.form.email || !this.form.password) {
//       this.error = 'Preencha nome, e-mail e senha.';
//       return;
//     }

//     this.loading = true;

//     this.api.post<any>('/customer-auth/register', this.form).subscribe({
//       next: (response) => {
//         localStorage.setItem('customer_token', response.token);
//         localStorage.setItem('customer_user', JSON.stringify(response.customer));
//         this.loading = false;
//        // this.router.navigate(['/customer/orders']);


//       },
//       error: (err) => {
//         this.loading = false;
//         this.error = err?.error?.message || 'Erro ao criar conta.';

//          const returnUrl =
//     this.route.snapshot.queryParamMap.get('returnUrl');

//   if (returnUrl) {
//     this.router.navigateByUrl(returnUrl);
//   } else {
//     this.router.navigate(['/']);
//   }
//       }
//     });
//   }
// }


import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  ActivatedRoute,
  Router,
  RouterLink
} from '@angular/router';

import { ApiService } from '../../core/api.service';

@Component({
  selector: 'app-customer-register',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink
  ],
  templateUrl: './customer-register.component.html',
  styleUrl: './customer-register.component.css'
})
export class CustomerRegisterComponent {

  loading = false;
  error = '';

  form = {
    name: '',
    email: '',
    phone: '',
    password: ''
  };

  constructor(
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}


  onPhoneChange(value: string): void {

    let numbers = String(value || '')
      .replace(/\D/g, '');

    // Caso venha com 55 na frente,
    // remove para manter apenas DDD + telefone na tela.
    if (
      numbers.startsWith('55') &&
      numbers.length > 11
    ) {
      numbers = numbers.substring(2);
    }

    // Máximo:
    // 2 dígitos DDD + 9 telefone
    numbers = numbers.substring(0, 11);


    if (!numbers) {
      this.form.phone = '';
      return;
    }


    if (numbers.length <= 2) {
      this.form.phone = `(${numbers}`;
      return;
    }


    const ddd = numbers.substring(0, 2);
    const phone = numbers.substring(2);


    // Enquanto ainda está digitando
    if (phone.length <= 4) {
      this.form.phone =
        `(${ddd}) ${phone}`;

      return;
    }


    // Telefone fixo:
    // (81) 3333-4444
    if (phone.length <= 8) {
      this.form.phone =
        `(${ddd}) ${phone.substring(0, 4)}-${phone.substring(4)}`;

      return;
    }


    // Celular:
    // (81) 99999-9999
    this.form.phone =
      `(${ddd}) ${phone.substring(0, 5)}-${phone.substring(5, 9)}`;
  }


  private getPhoneNumbers(): string {

    return String(
      this.form.phone || ''
    ).replace(/\D/g, '');

  }


  private getPhoneForApi(): string {

    const numbers =
      this.getPhoneNumbers();

    if (!numbers) {
      return '';
    }

    return `55${numbers}`;
  }


  private validatePhone(): boolean {

    const numbers =
      this.getPhoneNumbers();


    if (!numbers) {

      this.error =
        'Informe seu telefone.';

      return false;
    }


    if (
      numbers.length !== 10 &&
      numbers.length !== 11
    ) {

      this.error =
        'Informe um telefone válido com DDD. Ex: (81) 99999-9999';

      return false;
    }


    return true;
  }


  register(): void {

    this.error = '';


    /* ==============================
       CAMPOS OBRIGATÓRIOS
       ============================== */

    if (
      !this.form.name.trim() ||
      !this.form.email.trim() ||
      !this.form.password
    ) {

      this.error =
        'Preencha nome, e-mail e senha.';

      return;
    }


    /* ==============================
       TELEFONE
       ============================== */

    if (!this.validatePhone()) {
      return;
    }


    this.loading = true;


    /* ==============================
       PAYLOAD PARA API
       ============================== */

    const payload = {

      ...this.form,

      name:
        this.form.name.trim(),

      email:
        this.form.email
          .trim()
          .toLowerCase(),

      phone:
        this.getPhoneForApi()

    };


    /* ==============================
       CADASTRO
       ============================== */

    this.api
      .post<any>(
        '/customer-auth/register',
        payload
      )
      .subscribe({

        next: (response) => {

          localStorage.setItem(
            'customer_token',
            response.token
          );


          localStorage.setItem(
            'customer_user',
            JSON.stringify(
              response.customer
            )
          );


          this.loading = false;


          /* ==============================
             REDIRECIONAMENTO
             ============================== */

          const returnUrl =
            this.route.snapshot
              .queryParamMap
              .get('returnUrl');


          if (returnUrl) {

            this.router.navigateByUrl(
              returnUrl
            );

          } else {

            this.router.navigate(['/']);

          }

        },


        error: (err) => {

          this.loading = false;

          this.error =
            err?.error?.message ||
            'Erro ao criar conta.';

        }

      });

  }

}